import { EnquiryForm, EnquiryFormValues } from './types';

/**
 * What the browser sends when an enquiry is submitted.
 *
 * Deliberately only the answers, which form they belong to, and the reCAPTCHA token. It carries no mapping
 * onto Salesforce names and no lead settings, because the server resolves the form definition itself and maps
 * the answers there - see OfferEnquiryLeadBuilder. A mapping sent from a browser is a mapping a caller can
 * edit, and it would decide which department a lead lands in and whether the opt-ins are set.
 *
 * Nor does it carry anything the server can determine for itself: the dealer for the postcode, the
 * timestamps, the client source, the page URL. Those belong to whatever publishes the lead, so the browser
 * cannot get them wrong or be made to lie about them.
 */
export interface EnquirySubmission {
  formId: string;
  offerUniqueName: string;
  values: EnquiryFormValues;
  recaptchaToken: string;
}

export function buildSubmission(
  form: EnquiryForm,
  offerUniqueName: string,
  values: EnquiryFormValues,
  recaptchaToken: string
): EnquirySubmission {
  return {
    formId: form.formId,
    offerUniqueName,
    values,
    recaptchaToken,
  };
}

/**
 * What the server reports back once the lead is published.
 *
 * externalLeadId is the key Salesforce and CDP both receive, minted server side; absent only when an older
 * build answered without a body.
 */
export interface EnquirySubmitted {
  externalLeadId?: string;
}
